import { createContext } from 'react'

type ContextState = {
  [key: string]: any
}

export const SplitPayContext = createContext({} as ContextState)
